import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMneu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.333 6.667h17.334a1.333 1.333 0 0 0 0-2.667H3.333a1.333 1.333 0 0 0 0 2.667Zm0 13.333h17.334a1.333 1.333 0 0 0 0-2.667H3.333a1.333 1.333 0 0 0 0 2.667Zm17.334-6.667H3.333a1.333 1.333 0 0 1 0-2.666h17.334a1.333 1.333 0 0 1 0 2.666Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMneu;
